import type { ExtractorEntry } from '@/types/bundle'

// "+ New Extractor"'s starting shape. `type` and `region` are seeded to the
// schema's own fixed values (extractors.schema.json: `type` is a one-value
// enum, `region` a const "eu-west-2") - neither is ever rendered as an
// editable field, only shown read-only for context, mirroring Product
// Types' read-only `mode` badge.
export function buildEmptyExtractor(): ExtractorEntry {
  return {
    type: 'bedrock_vision_extractor',
    enabled: false,
    model_id: '',
    region: 'eu-west-2',
  }
}

// "Duplicate" clones every field, including `prompt_template_file` - unlike
// product/document baselines (where two entities sharing one prompt file
// was the exact bug being avoided), two extractor configs intentionally
// sharing the same default prompt is a reasonable starting point (e.g. a
// duplicate created to try a different tier/region with the same prompt).
export function cloneForDuplicateExtractor(source: ExtractorEntry): ExtractorEntry {
  return structuredClone(source)
}
